import React, {
  FC,
  createContext,
  useState,
  useMemo,
  useContext,
  useEffect,
} from 'react';
import { useSearchResponseQuery } from 'clientState/providers/SearchResponseProvider';

type FavoriteLayerActionsContextType = {
  open: () => void;
  close: () => void;
};

const FavoriteLayerContext = createContext(false);
const FavoriteLayerActionsContext = createContext({
  open: () => {},
  close: () => {},
});

const FavoriteLayerProvider: FC = ({ children }) => {
  const [isOpen, setOpen] = useState(false);
  const { data } = useSearchResponseQuery();
  const actions = useMemo(
    () => ({
      open: (): void => setOpen(true),
      close: (): void => setOpen(false),
    }),
    [setOpen]
  );

  useEffect(() => {
    setOpen(false);
  }, [data, setOpen]);

  return (
    <FavoriteLayerContext.Provider value={isOpen}>
      <FavoriteLayerActionsContext.Provider value={actions}>
        {children}
      </FavoriteLayerActionsContext.Provider>
    </FavoriteLayerContext.Provider>
  );
};

export const useIsFavoriteLayerOpen = (): boolean =>
  useContext(FavoriteLayerContext);
export const useFavoriteLayerActions = (): FavoriteLayerActionsContextType =>
  useContext(FavoriteLayerActionsContext);

export default FavoriteLayerProvider;
